import { IActionBase, ILanguageState } from '../models/root.interface';
import {
	ADD_LANGUAGE,
	CLEAR_LANGUAGES,
	ADD_DEFAULT_LANGUAGE,
} from '../actions/language.action';

const initialState: ILanguageState = {
	language: [],
	defaultLanguage: '',
};
function langReducer(
	state: ILanguageState = initialState,
	action: IActionBase
): ILanguageState {
	switch (action.type) {
		case ADD_LANGUAGE: {
			let maxId: number = Math.max.apply(
				Math,
				state.language.map((o) => o.id)
			);
			if (maxId === -Infinity) {
				maxId = 0;
			}
			let newItem = {
				id: maxId + 1,
				langKey: action.langKey,
				langVal: action.langVal,
			};
			return { ...state, language: [...state.language, newItem] };
		}
		case CLEAR_LANGUAGES:
			return { ...state, language: [] };
		case ADD_DEFAULT_LANGUAGE:
			return { ...state, defaultLanguage: action.defaultLanguage };
		default:
			return state;
	}
}

export default langReducer;
